import React from 'react'
import { BenefitsWidgetCardType } from '../../common-types'
import { StencilCDNImage } from '@/components/Common/StencilImage'

interface BenefitCardProps extends BenefitsWidgetCardType {
  isLeft: boolean
}

const ImageComponent = ({ imageUrl, altText, shadowColor, isLeft }) => {
  return (
    <div
      style={{
        boxShadow: `${isLeft ? '-' : ''}6px 0 10px 0 ${shadowColor}`,
        backgroundColor: shadowColor,
      }}
      className="flex h-[9.5rem] w-[9.5rem] items-center justify-center rounded-full border-4 border-white"
    >
      <StencilCDNImage
        className="rounded-full object-contain"
        src={imageUrl}
        width={150}
        height={150}
        alt={altText}
      />
    </div>
  )
}

const BenefitCard = ({
  titleHTML,
  description,
  imageUrl,
  shadowColor,
  isLeft,
}: BenefitCardProps) => {
  return (
    <div
      className={`relative mx-auto mt-4 flex flex-col items-center md:w-full md:flex-row md:items-center lg:w-4/5
        ${isLeft ? 'md:float-left md:mr-auto' : 'md:float-right md:ml-auto'}`}
    >
      <div
        className="w-50 h-50 -translate-y-5/10 absolute top-1/2 z-[1] hidden lg:block"
        style={isLeft ? { left: '-5%' } : { right: '-5%' }}
      >
        <ImageComponent
          altText={titleHTML}
          imageUrl={imageUrl}
          shadowColor={shadowColor}
          isLeft={isLeft}
        />
      </div>

      <div
        className={`relative z-0 mt-16 rounded-lg bg-white p-6 text-center shadow-md md:ml-6 md:mt-0 ${
          isLeft ? 'lg:pl-[14%]' : 'lg:pr-[14%]'
        }`}
        style={{
          boxShadow: `${isLeft ? '' : '-'}10px 10px 2px 0 ${shadowColor}`,
        }}
      >
        <div className="mb-4 flex justify-center lg:hidden">
          <ImageComponent
            altText={titleHTML}
            imageUrl={imageUrl}
            shadowColor={shadowColor}
            isLeft={false}
          />
        </div>
        <div
          className="text-center text-xl font-normal text-gray-800 lg:text-left"
          dangerouslySetInnerHTML={{ __html: titleHTML }}
        />
        <p className="mt-2 text-center leading-loose text-gray-600 lg:text-left">
          {description}
        </p>
      </div>
    </div>
  )
}

export default BenefitCard
